import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Logo.svg'


const _hoisted_1 = {
  id: "Footer",
  class: "relative w-full overflow-hidden bg-slate-950 px-[4%] py-5 md:h-24"
}
const _hoisted_2 = { class: "flex h-full flex-col content-center items-center justify-evenly space-y-3 md:flex-row md:space-y-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-full flex-[1_0_1%] flex-row content-center items-center justify-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    class: "w-10",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "mx-2 text-center text-sm font-semibold" }, /*#__PURE__*/_toDisplayString('LynxNode Ventures limited'))
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex h-full flex-[1_0_1%] flex-col items-center justify-center text-center text-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, "All Rights Reserved"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "© Copyright "),
    /*#__PURE__*/_createElementVNode("span", null, "LynxNode Ventures Limited")
  ])
], -1)
const _hoisted_5 = { class: "divide-y-1 flex h-full flex-[1_0_1%] flex-col items-center justify-center space-y-0 md:items-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "text-sm text-amber-500",
          to: "/"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "text-sm text-amber-500",
          to: "/privacy-policy"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Privacy Policy")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "text-sm text-amber-500",
          to: "/#Contact"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact Us")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}